import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import axios from "axios";
import { UserInfo } from "../../../context";
import StoreAdminLayout from "../../layout/StoreAdminLayout";
import { AuditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const MerchantList = () => {
  const [search, setSearch] = useState("");
  const [merchantList, setMerchantList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Registered Name",
      //   dataIndex: "customer_name",
      render: (text, record) => (
        <p>
          {text.branchmerchant.reg_firstname} {text.branchmerchant.reg_lastname}
        </p>
      ),
    },
    {
      title: "Business Name",
      //   dataIndex: ["branchmerchant", "business_name"],
      render: (text, record) => <p>{text.branchmerchant.business_name}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 80 }}>
          <Tooltip title="Merchant Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                // setSelectedData(text);
                // setOpenDrawer(true);
                navigate(
                  `/${text.branchmerchant?.user_id}/${text.branchmerchant?.business_name}`
                );
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>

          {/* <Tooltip title="Delete Order">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip> */}
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/store-admin/get/merchant-list", { params })
      .then((response) => {
        const data = response.data;
        setMerchantList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantList();
  }, [getMerchantList]);

  const searchable = merchantList.data.filter((data) => {
    return (
      data.branchmerchant.reg_firstname
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0 ||
      data.branchmerchant.reg_lastname
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0 ||
      data.branchmerchant.business_name
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  return (
    <StoreAdminLayout>
      <div style={{ overflowX: "auto" }}>
        <div style={{ marginBottom: 10 }}>
          <Input
            id="search"
            placeholder="Search name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {/* {openDrawer && (
        <MerchantOrdersDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => rerunCustomerOrders()}
          selectedData={selectedData}
          merchantList={merchantList}
        />
      )} */}
    </StoreAdminLayout>
  );
};

export default MerchantList;
